import {
  Button,
  ChatBubbleLeftRightIcon,
  danger,
  modalHandler,
  PaperAirplaneIcon,
  sendSMS,
  success,
  useLoading,
  useState,
} from "@";

const SendSMSMessage = ({ info, isSmsBalanceLow }) => {
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!message) {
      danger("الرجاء كتابة محتوى الرسالة");
      return;
    }

    setIsLoading(true);
    try {
      await sendSMS({
        Src: "",
        RecipientNumbers: [info.phone],
        body: message,
        delayInMin: 0,
      });
      modalHandler();
      setMessage("");
      success("تم الارسال");
    } finally {
      setIsLoading(false);
    }
  };

  const charCount = message.length;
  const smsParts = Math.max(1, Math.ceil(charCount / 70));

  return (
    <form
      onSubmit={handleSendMessage}
      className="grid gap-5 p-5 md:grid-cols-2"
    >
      {/* Recipient summary */}
      <div className="relative overflow-hidden rounded-2xl border border-purple-100 bg-gradient-to-l from-purple-50/40 via-white to-purple-50/30 p-3 dark:border-purple-800/40 dark:from-purple-950/30 dark:via-gray-800 dark:to-purple-950/20 md:col-span-2">
        <span
          aria-hidden
          className="pointer-events-none absolute -end-8 -top-8 h-24 w-24 rounded-full bg-gradient-to-br from-purple-200/40 to-transparent blur-2xl dark:from-purple-700/30"
        />
        <div className="relative flex items-center gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-purple-800 to-purple-950 text-white shadow-md shadow-purple-900/25 ring-1 ring-purple-900/10 dark:from-purple-600 dark:to-purple-800">
            <ChatBubbleLeftRightIcon className="h-5 w-5" />
          </span>
          <div className="min-w-0 flex-1">
            <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-purple-700 dark:text-purple-400">
              المستلم
            </p>
            <h3 className="truncate text-sm font-bold tracking-tight text-gray-900 dark:text-gray-100">
              {info?.userName || "—"}
            </h3>
            <p
              dir="ltr"
              className="font-mono text-xs tabular-nums text-gray-500 dark:text-gray-400"
            >
              {info?.phone || "—"}
            </p>
          </div>
        </div>
      </div>

      {/* Message field */}
      <div className="md:col-span-2">
        <div className="mb-2 flex items-end justify-between">
          <label className="input-label !mb-0">
            محتوى الرسالة
            <span className="star">*</span>
          </label>
          <div className="flex items-center gap-2 text-[11px] text-gray-500 dark:text-gray-400">
            <span className="font-mono tabular-nums">{charCount}</span>
            <span className="opacity-50">·</span>
            <span className="inline-flex items-center gap-1 rounded-full bg-purple-50 px-2 py-0.5 font-bold text-purple-900 ring-1 ring-purple-100 dark:bg-purple-950/40 dark:text-purple-300 dark:ring-purple-800/40">
              {smsParts} {smsParts === 1 ? "رسالة" : "رسائل"}
            </span>
          </div>
        </div>
        <textarea
          rows="5"
          className="input"
          value={message}
          onChange={handleMessageChange}
          placeholder="اكتب نص الرسالة هنا..."
        />
      </div>

      {/* Submit */}
      <div className="flex items-center justify-end md:col-span-2">
        <Button
          type="submit"
          title="إرسال"
          isLoading={isLoading}
          disabled={isSmsBalanceLow}
        >
          <PaperAirplaneIcon className="h-5 w-5 rtl:-scale-x-100" />
        </Button>
      </div>
    </form>
  );
};

export default SendSMSMessage;
